import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Blog = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Blog' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M5,16 C3.343,16 2,17.343 2,19 C2,20.657 3.343,22 5,22 C6.657,22 8,20.657 8,19 C8,17.343 6.657,16 5,16 L5,16 L5,16 Z M5,1 C14.925,1 23,9.075 23,19 L23,19 M18,19 C18,11.832 12.168,6 5,6 M13,19 C13,14.589 9.411,11 5,11 M2,11 L2,19 L2,19' />
  </StyledIcon>
);
